module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/components/tools/select2/select2-multi-groups/select2-multi-groups.component.scss
// module id = ./src/app/components/tools/select2/select2-multi-groups/select2-multi-groups.component.scss
// module chunks = main